/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetTasksInLocationQueryResult } from '../../models/get-tasks-in-location-query-result';

export interface ApiProjectMaintenanceReportGetTasksInLocationGet$Plain$Params {
  LocationId?: string;
}

export function apiProjectMaintenanceReportGetTasksInLocationGet$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectMaintenanceReportGetTasksInLocationGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetTasksInLocationQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectMaintenanceReportGetTasksInLocationGet$Plain.PATH, 'get');
  if (params) {
    rb.query('LocationId', params.LocationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetTasksInLocationQueryResult>;
    })
  );
}

apiProjectMaintenanceReportGetTasksInLocationGet$Plain.PATH = '/api/ProjectMaintenanceReport/GetTasksInLocation';
